var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    [
      _c(
        "v-col",
        { staticClass: "pa-1" },
        [
          _c("v-text-field", {
            attrs: {
              label: "Element name",
              "hide-details": "",
              disabled: "",
              solo: ""
            },
            model: {
              value: _vm.configItem.elementName,
              callback: function($$v) {
                _vm.$set(_vm.configItem, "elementName", $$v)
              },
              expression: "configItem.elementName"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-col",
        { staticClass: "pa-1" },
        [
          _c("v-autocomplete", {
            attrs: {
              label: "Anonymization Method",
              "hide-details": "",
              items: _vm.anonymizationMethods,
              solo: "",
              clearable: "",
              "return-object": ""
            },
            model: {
              value: _vm.configItem.method,
              callback: function($$v) {
                _vm.$set(_vm.configItem, "method", $$v)
              },
              expression: "configItem.method"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-col",
        { staticClass: "pa-1" },
        [
          _c("v-autocomplete", {
            attrs: {
              label: "Input",
              "hide-details": "",
              items: _vm.sortInputs(_vm.inputs),
              disabled: _vm.checkavailability(_vm.configItem.method),
              solo: "",
              "item-text": "key",
              "return-object": "",
              clearable: ""
            },
            model: {
              value: _vm.configItem.input,
              callback: function($$v) {
                _vm.$set(_vm.configItem, "input", $$v)
              },
              expression: "configItem.input"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }